import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ShopInner from '../Components/Shop/ShopInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Shop() {
    return (
        <>
            <SEO 
                title="Travel Shop - Tourm Travel Agency"
                description="Browse our travel shop for travel accessories, guides, and essentials for your next trip."
                url="/shop"
            />
            <HeaderOne />
            <Breadcrumb
                title="Shops"
            />
            <ShopInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Shop
